module.exports = __webpack_public_path__ + "4a8563b04066ba61c8707a8a8ca379a2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/rocket-ship.png
// module id = 593
// module chunks = 0